import React from "react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export const PageTitle = ({ overline, title, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-6">
    <div>
      {overline && <p className="overline">{overline}</p>}
      <h1 className="font-heading font-extrabold text-3xl sm:text-4xl tracking-tight mt-1">{title}</h1>
    </div>
    {children && <div className="flex items-center gap-2 flex-wrap">{children}</div>}
  </div>
);

export const StatCard = ({ icon: Icon, label, value, sub, accent = "text-primary" }) => (
  <Card className="p-5 border-border hover:-translate-y-1 hover:shadow-md transition-transform duration-200 rounded-md">
    <div className="flex items-start justify-between">
      <p className="overline">{label}</p>
      {Icon && <Icon className={cn("h-5 w-5", accent)} />}
    </div>
    <p className="font-heading font-extrabold text-3xl mt-3 font-mono-num">{value}</p>
    {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
  </Card>
);

export const SectionCard = ({ title, action, children, className }) => (
  <Card className={cn("border-border rounded-md", className)}>
    {(title || action) && (
      <div className="flex items-center justify-between px-5 py-4 border-b border-border">
        <h3 className="font-heading font-bold text-base">{title}</h3>
        {action}
      </div>
    )}
    <div className="p-5">{children}</div>
  </Card>
);

export const StatusBadge = ({ status }) => {
  const map = {
    Approved: "bg-success/10 text-success border-success/20",
    Rejected: "bg-destructive/10 text-destructive border-destructive/20",
    Pending: "bg-warning/10 text-warning border-warning/30",
    Active: "bg-success/10 text-success border-success/20",
    "On Leave": "bg-warning/10 text-warning border-warning/30",
    "Clocked In": "bg-success/10 text-success border-success/20",
    "Clocked Out": "bg-muted text-muted-foreground border-border",
    Absent: "bg-destructive/10 text-destructive border-destructive/20",
    Resigned: "bg-muted text-muted-foreground border-border",
    Terminated: "bg-destructive/10 text-destructive border-destructive/20",
  };
  return (
    <span className={cn("inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border", map[status] || "bg-muted text-muted-foreground border-border")}>
      {status}
    </span>
  );
};
